import React from 'react';

const CallbackContext = React.createContext();
// Filter is used to ensure that a callback isn't recursively calling itself.
function getFilter(exclude, include) {
    return c => (!exclude || !exclude.includes(c.symbol))
        && (!include || include.includes(c.symbol));
};

export function CallbackContextProvider({callbackRef, children}) {
    const callbacks = React.useRef([]);
    const value = React.useMemo(() => {
        const result = ({
            callback: async (exclude, include) => {
                const filter = getFilter(exclude, include);
                return await Promise.all(callbacks.current
                    .map(callback => filter(callback) && callback()));
            },
            callbacks: (exclude, include) => callbacks.current.filter(getFilter(exclude, include)),
            addCallback: (callback) => {
                callbacks.current.push(callback); 
            },
            removeCallback: (callback) => {
                const filter = typeof(callback) === "symbol"? (c => c.symbol !== callback)
                    : (c => c !== callback);
                callbacks.current = callbacks.current.filter(filter);
            },
        });
        if (callbackRef) callbackRef.current = result;
        return result;
    }, [callbackRef]);
    return (
        <CallbackContext.Provider value={value}>
            {children}
        </CallbackContext.Provider>
    );
}

export default function useCallbackContext() {
    return React.useContext(CallbackContext);
}
